(() => {
  const params = window.ScSearchScope.normalize(new URLSearchParams(location.search));
  document.querySelectorAll('.tcg-pagination a').forEach(link => {
    const url = new URL(link.href);
    for (const key of ['base_q', 'game', 'format', 'category', 'origin', 'sort_by', 'options[prefix]', 'refinement']) {
      if (params.has(key)) url.searchParams.set(key, params.get(key));
    }
    for (const key of new Set([...params.keys()].filter(key => key.startsWith('filter.')))) {
      url.searchParams.delete(key);
      for (const value of params.getAll(key)) url.searchParams.append(key, value);
    }
    link.href = url.pathname + url.search;
  });
  const nav = document.querySelector('[data-sc-accessory-nav]');
  if (nav && (nav.dataset.mode !== 'search' || params.get('format') === 'accessory')) {
    nav.hidden = false;
    const game = window.ScSearchScope.read(params, nav.dataset.game).game;
    const category = params.get('category') || nav.dataset.category || '';
    const origin = ['official', 'fan-made', 'third-party'].includes(params.get('origin')) ? params.get('origin') : '';
    const categoryFilterValues = {
      'card-sleeves': 'Sleeves',
      'deck-boxes': 'Deck Boxes',
      playmats: 'Playmats',
      binders: 'Binders',
      'token-packs': 'Token Packs',
      others: 'Others'
    };
    const parent = nav.querySelector('[data-sc-accessory-parent]');
    const scoped = ['Riftbound', 'Pokemon', 'One Piece', 'Dragon Ball', 'Gundam', 'Digimon'].includes(game);
    const hub = game === 'Gundam' ? nav.dataset.gundamHub : game === 'Digimon' ? nav.dataset.digimonHub : game === 'Dragon Ball' ? nav.dataset.dragonBallHub : game === 'One Piece' ? nav.dataset.onePieceHub : game === 'Pokemon' ? nav.dataset.pokemonHub : nav.dataset.riftHub;
    const channel = game === 'Gundam' ? nav.dataset.gundamChannel : game === 'Digimon' ? nav.dataset.digimonChannel : game === 'Dragon Ball' ? nav.dataset.dragonBallChannel : game === 'One Piece' ? nav.dataset.onePieceChannel : game === 'Pokemon' ? nav.dataset.pokemonChannel : nav.dataset.riftChannel;
    parent.href = scoped ? hub : nav.dataset.hub;
    if (scoped && nav.dataset.game !== game) {
      const link = document.createElement('a');
      link.href = channel;
      link.textContent = game === 'Pokemon' ? 'Pokémon' : game;
      const separator = document.createElement('span');
      separator.textContent = '/';
      parent.before(link, separator);
    }
    const queries = {};
    nav.querySelectorAll('[data-sc-category]').forEach(link => { queries[link.dataset.scCategory] = link.dataset.query.trim(); });
    const categoryLink = [...nav.querySelectorAll('[data-sc-category]')].find(link => link.dataset.scCategory === category && category);
    if (categoryLink) {
      const separator = document.createElement('span'); separator.textContent = '/';
      const label = document.createElement('span'); label.textContent = categoryLink.textContent;
      label.setAttribute('aria-current', 'page'); parent.after(separator, label);
    }
    const destination = (nextCategory, nextOrigin) => {
      const url = new URL(nav.dataset.search, location.origin);
      const query = ['((product_type:"Accessory" OR product_type:"DIY Product")) AND -product_type:"Gift Card" AND -product_type:"Shipping Upgrade"'];
      if (game && !scoped) query.push('"' + game.replaceAll('"', '') + '"');
      if (queries[nextCategory]) query.push(queries[nextCategory]);
      if (nextOrigin) query.push('tag:' + nextOrigin);
      const base = params.get('base_q') || '';
      const exactSku = (params.get('q') || '').match(/variants\.sku:"(?:\\.|[^"\\])*"/);
      if (base) query.push(exactSku ? exactSku[0] : base);
      url.searchParams.set('options[prefix]', exactSku ? 'none' : 'last');
      url.searchParams.set('type', 'product'); url.searchParams.set('format', 'accessory');
      url.searchParams.set('base_q', base); url.searchParams.set('q', query.join(' AND '));
      if (game) url.searchParams.set('game', game);
      if (queries[nextCategory]) url.searchParams.set('category', nextCategory);
      if (nextOrigin) url.searchParams.set('origin', nextOrigin);
      for (const [key, value] of params) if ((key.startsWith('filter.') || key === 'sort_by') && key !== 'filter.p.m.custom.accessory_category') url.searchParams.append(key, value);
      if (categoryFilterValues[nextCategory]) url.searchParams.set('filter.p.m.custom.accessory_category', categoryFilterValues[nextCategory]);
      if (scoped) url.searchParams.set('filter.p.m.custom.game', game);
      return url.pathname + url.search;
    };
    nav.querySelectorAll('[data-sc-category]').forEach(link => {
      link.href = destination(link.dataset.scCategory, origin);
      if (link.dataset.scCategory === category) link.setAttribute('aria-current', 'page');
    });
    nav.querySelectorAll('[data-sc-origin]').forEach(link => {
      link.href = destination(category, link.dataset.scOrigin);
      if (link.dataset.scOrigin === origin) link.setAttribute('aria-current', 'page');
    });
    if (nav.dataset.mode === 'search') {
      document.querySelectorAll('.tcg-product-card a[href*="/products/"]').forEach(link => {
        const url = new URL(link.href);
        url.searchParams.set('sc_accessory', '1');
        if (scoped) url.searchParams.set('sc_game', game);
        if (queries[category]) url.searchParams.set('sc_category', category);
        if (origin) url.searchParams.set('sc_origin', origin);
        link.href = url.pathname + url.search;
      });
    }
  }
  const crumb = document.querySelector('[data-sc-accessory-product]');
  if (crumb && params.get('sc_accessory') === '1') {
    const game = ['Riftbound', 'Pokemon', 'One Piece', 'Dragon Ball', 'Gundam', 'Digimon'].includes(params.get('sc_game')) ? params.get('sc_game') : '';
    const parent = crumb.querySelector('[data-sc-product-format]');
    if (game) {
      parent.href = game === 'Gundam' ? crumb.dataset.gundamHub : game === 'Digimon' ? crumb.dataset.digimonHub : game === 'Dragon Ball' ? crumb.dataset.dragonBallHub : game === 'One Piece' ? crumb.dataset.onePieceHub : game === 'Pokemon' ? crumb.dataset.pokemonHub : crumb.dataset.riftHub;
      if (!crumb.querySelector('[data-sc-product-game]')) {
        const link = document.createElement('a'); link.href = game === 'Gundam' ? crumb.dataset.gundamChannel : game === 'Digimon' ? crumb.dataset.digimonChannel : game === 'Dragon Ball' ? crumb.dataset.dragonBallChannel : game === 'One Piece' ? crumb.dataset.onePieceChannel : game === 'Pokemon' ? crumb.dataset.pokemonChannel : crumb.dataset.riftChannel; link.textContent = game === 'Pokemon' ? 'Pokémon' : game;
        const separator = document.createElement('span'); separator.textContent = '/';
        parent.before(link, separator);
      }
    }
    const category = params.get('sc_category');
    const source = [...crumb.querySelectorAll('[data-sc-product-category]')].find(link => link.dataset.scProductCategory === category);
    if (source) {
      source.hidden = false;
      const url = new URL(source.href);
      const categoryFilterValues = {
        'card-sleeves': 'Sleeves',
        'deck-boxes': 'Deck Boxes',
        playmats: 'Playmats',
        binders: 'Binders',
        'token-packs': 'Token Packs',
        others: 'Others'
      };
      if (game) { url.searchParams.set('game', game); url.searchParams.set('filter.p.m.custom.game', game); }
      if (categoryFilterValues[category]) url.searchParams.set('filter.p.m.custom.accessory_category', categoryFilterValues[category]);
      const origin = params.get('sc_origin');
      if (['official', 'fan-made'].includes(origin)) { url.searchParams.set('origin', origin); url.searchParams.set('q', url.searchParams.get('q') + ' AND tag:' + origin); }
      source.href = url.pathname + url.search;
      const separator = document.createElement('span'); separator.textContent = '/'; source.after(separator);
    }
  }
})();
